import React, { useEffect, useState } from "react";
import ReactDOMClient from "react-dom/client";
import { CarouselProvider } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { Marker } from "./types";
import { LarekSlider } from "./LarekSlider";
import { Map } from "./Map";
import { showSidebar } from "@/sidebar";

const load = async () => {
  const ymaps3Reactify = await ymaps3.import("@yandex/ymaps3-reactify");

  const Gallery = () => {
    const [markers, setMarkers] = useState<Marker[]>([]);
    const [activeItem, setActiveItem] = useState<Marker | null>(null);
    const [currentSlide, setCurrentSlide] = useState(0);

    const getMarkers = async (): Promise<Marker[]> => {
      const response = await fetch("/api/gallery/get");
      const result = response.json();
      return result;
    };

    useEffect(() => {
      (async () => {
        setMarkers(await getMarkers());
      })();
    }, []);

    useEffect(() => {
      setCurrentSlide(0);
    }, [activeItem]);

    return (
      <div>
        <Map
          markers={markers}
          setActiveItem={setActiveItem}
          ymaps3Reactify={ymaps3Reactify}
        />
        {activeItem && (
          <div className="fixed top-0 right-0 h-screen w-full bg-white z-40 shadow-lg transform transition-transform duration-200 ease-in-out px-5">
            <div className="container mx-auto pt-2">
              <div className="py-6 flex justify-end">
                <button
                  onClick={() => setActiveItem(null)}
                  className="focus:outline-none"
                  data-action="toggle-sidebar"
                >
                  <span
                    id="line1"
                    className="block w-8 h-0.5 bg-black transition-all duration-300 rotate-45 transform translate-y-1.5"
                  ></span>
                  <span
                    id="line2"
                    className="block w-8 h-0.5 mt-1 bg-black transition-all duration-300 -rotate-45"
                  ></span>
                </button>
              </div>
              <div className="flex flex-col gap-4 lg:flex-row">
                <div className="w-full lg:w-1/4">
                  <h2 className="text-xl lg:text-3xl uppercase font-bold pb-5">
                    {activeItem.title}
                  </h2>

                  <div>{activeItem.address}</div>

                  <button
                    className="rounded-full border border-gray-600 py-4 px-6 text-gray-600 mt-4"
                    onClick={showSidebar}
                  >
                    Отправить заявку
                  </button>
                </div>
                <div className="w-full lg:w-3/4">
                  <CarouselProvider
                    naturalSlideWidth={100}
                    naturalSlideHeight={60}
                    currentSlide={currentSlide}
                    totalSlides={activeItem.images.length}
                    infinite={true}
                  >
                    <LarekSlider
                      activeItem={activeItem}
                      setCurrentSlide={setCurrentSlide}
                      currentSlide={currentSlide}
                    />
                  </CarouselProvider>
                </div>
              </div>
            </div>
          </div>
        )}
        {/** Start Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-5">
          {markers.map((item, index) => {
            return (
              <div key={index} onClick={() => setActiveItem(item)}>
                <img
                  src={`/uploads/240x180/${item.coverImage}`}
                  className="w-full"
                />
                <div className="py-5 font-semibold lg:text-xl">
                  {item.title}
                </div>
                <div className="text-sm lg:text-lg">{item.address}</div>
              </div>
            );
          })}
        </div>
        {/* End Grid */}
      </div>
    );
  };

  const container = document.getElementById("gallery");
  if (container) {
    const root = ReactDOMClient.createRoot(container);
    root.render(<Gallery />);
  }
};

load();
